import './AgentRow.scss'

import React, {Component} from 'react'
import { Button } from 'react-bootstrap'
import classNames from 'classnames'
import {
  RQ_STATUS_STARTED,
  RQ_STATUS_FINISHED,
  RQ_STATUS_FAILED,
  BROKER_REMOVED_REASON_DEPARTING,
  BROKER_REMOVED_REASON_OPT_OUT,
  BROKER_REMOVED_REASON_MOVED,
  METRIC_TYPE_CLOSED_DEALS,
  METRIC_TYPE_MET_CLIENTS,
  METRIC_TYPE_STATUS_UPDATED,
  METRIC_TYPE_CLAIMED_LEADS,
  METRIC_LOCK_LABELS,
  METRIC_TYPE_CONTACTING_REFERRALS,
} from 'common/constants'
import { get } from 'common/util/helper'
import { getColorForPercentile, getMetricDescription } from 'common/util/metrics_helper'
import { masqueradeAgent, fetchAgentDepartureAgreement, checkJobStatus } from 'broker/redux/account'
import { show as showModal } from 'redux-modal'
import { push } from 'react-router-redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import { segmentEventTracker } from 'common/analytics'


const ShowReferralsButton = ({ onClick }) => {
  return (
    <div className="AgentRow__show-referrals">
      <div onClick={onClick}>Show referrals</div>
    </div>
  )
}

const StatsItem = ({ className, label, value, highlighted, success }) => {
  const valueClassName = classNames('AgentRowDetail__value', {
    'AgentRowDetail--highlight': highlighted,
    '-success': success,
  })

  return (
    <div className={className}>
      <div className="AgentRowDetail__label">{ label }</div>
      <div className={valueClassName}>{ value }</div>
    </div>
  )
}

const DetailItem = ({ label, value, link }) => {
  return (
    <div className="AgentRowContact__item">
      <div className="AgentRowContact__label">{ label }</div>
      { link ?
        <div className="AgentRowContact__value--wrap"><a href={ link }>{ value }</a></div> :
        <div className="AgentRowContact__value">{ value }</div> }
    </div>
  )
}

const MetricsDetailItem = ({ label, value }) => {
  return (
    <div className="AgentRowContact__item">
      <div className="AgentRowContact__metrics-label">{ label }</div>
      <div className="AgentRowContact__metrics-value">{ value }</div>
    </div>
  )
}

const PerformanceMetricItem = ({ agent, label, metricType }) => {
  const unlockAt = _.get(agent, [`${metricType}_unlock_at`])
  const numerator = Math.round(_.get(agent, [`${metricType}_numerator`]) || 0)
  const denominator = Math.round(_.get(agent, [`${metricType}_denominator`]) || 0)
  const percentile = Math.round((_.get(agent, [`${metricType}_percentile`]) || 0) * 100)

  let description = ''
  let backgroundColor = '#9b9b9b'
  if (unlockAt) {
    const isEmpty = numerator === 0 && denominator === 0 && metricType !== METRIC_TYPE_CLOSED_DEALS
    if (isEmpty) {
      description = 'Not enough data to display'
    } else {
      backgroundColor = getColorForPercentile(percentile)
      description = getMetricDescription(metricType, numerator, denominator)
    }
  } else {
    backgroundColor = '#ececec'
    description = METRIC_LOCK_LABELS[metricType]
  }

  return (
    <div className="AgentRowContact__item">
      { unlockAt ?
        <div className="AgentRowContact__metric-icon" style={{backgroundColor}} /> :
        <div className="AgentRowContact__metric-locked"/>
      }
      <div className="AgentRowContact__metrics-right">
        <div className="AgentRowContact__metrics-label">{label}</div>
        <div className="AgentRowContact__metrics-value">{description}</div>
      </div>
    </div>
  )
}

const AgentRowDetails = ({ agent, showRemoveModal }) => {
  const {
    is_broker_removed,
    experience_level,
    email,
    phone,
    last_updated,
    license,
    distance,
    base_zip,
    client_types,
    price_ranges,
    property_types,
  } = agent

  return (
    <div className="AgentRowContact">
      <div className="AgentRowContact__top">
        <div className="AgentRowContact__header">Agent Details</div>
        { last_updated && <div className="AgentRowContact__updated">Settings Last Updated: <strong>{ last_updated }</strong></div> }
      </div>
      <div className="AgentRowContact__body">
        <div className="AgentRowContact__left">
          <DetailItem label="Email" value={ email } link={'mailto:' + email} />
          <DetailItem label="Phone" value={ phone }/>
          <DetailItem label="Agent Type" value={ experience_level || 'Experienced' } />
          <DetailItem label="License #" value={ license }/>
          { !is_broker_removed && <Button className="btn btn-danger" onClick={showRemoveModal}>Terminate Agent</Button> }
        </div>
        <div className="AgentRowContact__right">
          <div className="AgentRowContact__metrics-top">
            <div className="AgentRowContact__column">
              <h2>Settings</h2>
            </div>
            <div className="AgentRowContact__column-wide">
              <MetricsDetailItem label="Location" value={`Within ${ distance } miles of ${ base_zip }`}/>
              <MetricsDetailItem label="Client Types" value={ client_types }/>
            </div>
            <div className="AgentRowContact__column-wide">
              <MetricsDetailItem label="Price Ranges" value={ price_ranges }/>
              <MetricsDetailItem label="Property Types" value={ property_types } />
            </div>
          </div>
          <div className="AgentRowContact__metrics-bottom">
            <div className="AgentRowContact__column">
              <h2>Performance</h2>
            </div>
            <div className="AgentRowContact__column-wide" style={{ maxHeight: 200 }}>
              <PerformanceMetricItem agent={agent} metricType={METRIC_TYPE_CLOSED_DEALS} label="Closing deals"/>
              <PerformanceMetricItem agent={agent} metricType={METRIC_TYPE_MET_CLIENTS} label="Meeting clients"/>
              <PerformanceMetricItem agent={agent} metricType={METRIC_TYPE_STATUS_UPDATED} label="Updating status"/>
              <PerformanceMetricItem agent={agent} metricType={METRIC_TYPE_CONTACTING_REFERRALS} label="Contacting referrals"/>
              <PerformanceMetricItem agent={agent} metricType={METRIC_TYPE_CLAIMED_LEADS} label="Claiming leads"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

class AgentRow extends Component {

  state = {
    showDetails: false,
    downloading: false,
    error: false,
  }

  handleDownload = async () => {
    const { fetchAgentDepartureAgreement, agent } = this.props

    this.setState({downloading: true})
    try {
      const response = await fetchAgentDepartureAgreement(agent.id)
      if (response.url) {
        this.setState({downloading: false})
        window.open(response.url, '_blank')
      } else {
        this.pollJobStatus(response.queue, response.job_id)
      }
    } catch (err) {
      this.setState({error: true})
    }
  }

  pollJobStatus = (queue, job_id) => {
    const { checkJobStatus } = this.props

    setTimeout(() => {
      checkJobStatus(queue, job_id).then(response => {
        if (response.status === RQ_STATUS_STARTED) {
          this.setState({ downloading: true })
          this.pollJobStatus(queue, job_id)
        } else if(response.status === RQ_STATUS_FINISHED) {
          this.setState({ downloading: false })
          window.open(response.result, '_blank')
        } else if(response.status === RQ_STATUS_FAILED) {
          this.setState({ downloading: false, error: true })
        } else {
          this.setState({ downloading: true })
          this.pollJobStatus(queue, job_id)
        }
      })
    }, 1000)
  }

  goToAgentReferrals = () => {
    const { agent, push } = this.props
    push({pathname:'/referrals', state:{ agentId: agent.id }})
  }

  masqueradeAgent = () => {
    const { agent, masqueradeAgent } = this.props

    masqueradeAgent(agent.id).then(response => {
      window.open(response.url, '_blank')
    })
  }

  toggleDetails = () => {
    this.setState(prevState => ({showDetails: !prevState.showDetails}))
  }

  showRemoveModal = () => {
    const { agent, showModal } = this.props
    showModal('RemoveAgentModal', {agent})
  }

  render() {
    const { agent, rank, auth} = this.props
    const { showDetails, error, downloading } = this.state
    const user = auth? auth.user : undefined
    const hideTrainingStat = user ? user.hide_agent_training_stat : false

    const {
      id,
      name,
      hash,
      is_broker_removed,
      broker_removed_reason,
      status,
      experience_level,
      is_assignable,
      agent_agreement_url,
      webinar_completed,
      existing_snooze,
      do_not_disturb,
      actual_volume,
      likely_to_close,
      total_transactions,
      closed,
      stats_won_count,
      stats_clicked_count,
      stats_sent_count,
      stats_avg_click_time,
    } = agent

    let rowClassNames = classNames('AgentRow' , {
      'AgentRow--disabled': !is_broker_removed && (['disabled', 'delinquent'].includes(status))
    })
    let badges = []
    let detailClassNames = classNames('AgentRowDetail__item', {
      'AgentRowDetail__item--removed': is_broker_removed
    })

    if (experience_level === 'emerging') {
      badges.push({label: 'Emerging', type:'emerging'})
    } else {
      badges.push({label: 'Experienced', type:'experienced'})
    }

    if (!is_broker_removed) {
      if (status == 'disabled') {
        badges.push({label: 'Overdue - At Risk of Reassigning Clients', type: 'danger'})
      } else if (status == 'delinquent') {
        badges.push({label: 'Delinquent', type: 'danger'})
      } else if (!is_assignable) {
        badges.push({label: 'Not Receiving Leads', type: 'danger'})
      }
    } else {
      if (broker_removed_reason === BROKER_REMOVED_REASON_OPT_OUT) {
        badges.push({label: 'Terminated - No longer participating', type: 'danger'})
      } else if (broker_removed_reason === BROKER_REMOVED_REASON_DEPARTING) {
        badges.push({label: 'Terminated - Departed Brokerage', type: 'danger'})
      } else if (broker_removed_reason === BROKER_REMOVED_REASON_MOVED) {
        badges.push({label: 'Terminated - Moved Brokerage', type: 'danger'})
      } else {
        badges.push({label: 'Terminated - Removed', type: 'danger'})
      }
    }

    let lastRowItem
    if (is_broker_removed) {
      if (!error) {
        lastRowItem = !downloading ?
          <div className="AgentRowDetail__item__departure">
            <p><a onClick={this.handleDownload}>Departure Agreement <i className="fa fa-download" /></a></p>
            <p><a href={agent_agreement_url} target="_blank" rel="noopener noreferrer">Agent Agreement <i className="fa fa-download" /></a></p>
          </div> :
          <div className="AgentRowDetail__item__departure">
            <p>Downloading <i className="fa fa-circle-o-notch rotating" aria-hidden="true"/></p>
            <p><a href={agent_agreement_url} target="_blank" rel="noopener noreferrer">Agent Agreement <i className="fa fa-download" /></a></p>
          </div>
      } else {
        lastRowItem = <div className="AgentRowDetail__item__departure">
          <p className="error-text"><i className="fa fa-exclamation-circle"/> Error: Please refresh the page and try again.</p>
          <p><a href={agent_agreement_url} target="_blank" rel="noopener noreferrer">Agent Agreement <i className="fa fa-download" /></a></p>
        </div>
      }
    } else {
      lastRowItem = <div className="AgentRowDetail__item">
        <div className="AgentRowDetail__label">Referral Manager</div>
        <div><a className="AgentRowDetail__masquerade" onClick={() => {
          segmentEventTracker('Sub-User Masqueraded', {
            'user_type': 'agent',
            'masqueraded_user_hash': hash
          })

          this.masqueradeAgent()
        }}>Login As Agent <i className="fa fa-arrow-circle-right" /></a></div>
      </div>
    }

    return <div className={rowClassNames} key={id}>
      <div className="AgentRow__rank">{ rank }.</div>
      <div className="AgentRow__item">
        <div className="AgentRow__flex">
          <span className="AgentRow__name" onClick={this.toggleDetails}>{ name }</span>
          <span className="AgentRow__chevron" onClick={this.toggleDetails}><i className={`fa fa-chevron-${showDetails ? 'up' : 'down'}`}/></span>
          { badges.map(badge => (<span className={"AgentRow__badge AgentRow__badge--"+badge.type} key={badge.type}>{ badge.label }</span>)) }
          { webinar_completed === 'Yes' && !hideTrainingStat && <div className="AgentRow__webinar" data-tip="Successfully completed training"></div> }
          { existing_snooze && <div className="AgentRow__snooze" data-tip={`Leads alerts paused (${existing_snooze})`}><i className="fa fa-moon-o"/></div> }
          { do_not_disturb && <div className="AgentRow__do-not-disturb" data-tip={do_not_disturb}><i className="fa fa-clock-o"/></div> }
        </div>
        <div className="AgentRowDetail">
          { is_broker_removed && <ShowReferralsButton onClick={this.goToAgentReferrals}/> }
          <StatsItem className={detailClassNames} label="Active Pipeline" value={ `$${actual_volume}` } success={true}/>
          <StatsItem className={detailClassNames} label="Likely Close" value={ likely_to_close } />
          <StatsItem className={detailClassNames} label="Transactions" value={ total_transactions }/>
          <StatsItem className={detailClassNames} label="Closes" value={ closed }/>
          <StatsItem className={detailClassNames} label="7-Day Won/Clicked/Sent" value={`${get(stats_won_count, '-') } / ${ get(stats_clicked_count, '-') } / ${ get(stats_sent_count, '-') }`} highlighted={true}/>
          <StatsItem className={detailClassNames} label="7-Day Avg Click" value={ get(stats_avg_click_time, '-') } highlighted={true}/>
          {lastRowItem}
        </div>
      </div>
      { showDetails && <AgentRowDetails agent={ agent } showRemoveModal={this.showRemoveModal}/> }
    </div>
  }
}

const actions = {
  fetchAgentDepartureAgreement,
  masqueradeAgent,
  showModal,
  push,
  checkJobStatus,
}

export default connect(null, actions)(AgentRow)
